import React from 'react';
import styles from 'components/frank/_style.module.scss';

// HOW MANY placeholders to draw while the solve runs. A fixed, small number on purpose: the solve is ONE
// request and how many cards it answers with is unknowable -- one plan on the reference quote answers with 1
// card, another with 5, others with 9 to 11. So these are texture that holds the page's shape, never a claim
// about what is coming, which is why they carry no counts, machines or labels.
const PLACEHOLDER_CARD_COUNT = 3;

// The solve's in-place state: the picked plan's own card stays on screen above this, and the grid area below it
// shows what is being worked on instead of a full-screen card over the whole page.
//
// The bar is INDETERMINATE. Unlike the listing -- which fires one request per manufacturing line and can count
// them -- the solve is a single request with no progress signal, so any percentage here would be invented.
const SolutionCardsSkeleton = () => (
  <div data-frank-solving>
    <div className={styles.solveLabel}>
      {t('quote_builder.solving_picked_plan')}
    </div>

    <div
      className={styles.solveProgress}
      role="progressbar"
      aria-label={t('quote_builder.solving_picked_plan')}
    />

    <div className={styles.solutionSkeletonGrid} aria-hidden="true">
      {Array.from({ length: PLACEHOLDER_CARD_COUNT }, (_placeholder, index) => (
        <div className={styles.solutionSkeletonCard} key={index}>
          <div className={`${styles.skeleton} ${styles.solutionSkeletonHeader}`} />
          <div className={styles.solutionSkeletonFigures}>
            <div className={`${styles.skeleton} ${styles.solutionSkeletonFigure}`} />
            <div className={`${styles.skeleton} ${styles.solutionSkeletonFigure}`} />
          </div>
          <div className={styles.solutionSkeletonFigures}>
            <div className={`${styles.skeleton} ${styles.solutionSkeletonFigure}`} />
            <div className={`${styles.skeleton} ${styles.solutionSkeletonFigure}`} />
          </div>
          <div className={`${styles.skeleton} ${styles.solutionSkeletonPanel}`} />
        </div>
      ))}
    </div>
  </div>
);

export default SolutionCardsSkeleton;
